// @core/api/endpoints/task/create_task_from_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTaskFromTemplateRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create task from template
 * Creates a new task populated with all fields from the template. Allows overriding title, assignee, parent, and due date.
 */
export async function CreateTaskFromTemplate(
  template_id: string,
  data: CreateTaskFromTemplateRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-templates/:template_id/create-task`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
